import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./ContentSharingConfigIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./containers/ContentSharingConfigListPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./containers/ContentSharingConfigFormPage'),
  loading: () => <Loading withContentWrapper />,
});
